import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  title: {
    id: 'report.additionalinfo.title',
    description: 'Title for reports additional info section',
    defaultMessage: 'Lisätiedot',
  },
  partnerInfo: {
    id: 'report.additionalinfo.partnerInfo',
    description: 'Info about partner sources.',
    defaultMessage: 'Luottoluokitukset näytetään vain niistä yrityksistä, jotka ovat ostaneet luottoluokituksen näkyvyviin maksullisena lisäpalveluna.',
  },
  
  // OTHERS
  readMoreBtn: {
    id: 'report.additionalinfo.readMoreBtn',
    defaultMessage: 'Lue lisää',
    description: 'Read more link button text',
  },
});
